import React from "react";
import {FormControl, SelectChangeEvent} from "@mui/material";
import {CustomMenuItem} from "./CustomMenuItem";
import {CustomSelect} from "./CustomSelect";
import {IconGlobe} from "../bounce-ui";
import {Colors} from "../../ui";

export const languages = [
  {code: "en", label: "English", fullValue: "english"},
  {code: "es", label: "Español", fullValue: "spanish"},
];

interface ILanguageSwitcherContent {
  currLanguage?: string;
  handleChange: (event: SelectChangeEvent<string>) => void;
}

export const LanguageSwitcherContent = ({currLanguage, handleChange}: ILanguageSwitcherContent) => {
  return (
    <FormControl sx={{marginTop: "20px"}}>
      <CustomSelect
        value={currLanguage}
        onChange={handleChange}
        renderValue={(value) => {
          const selectedLanguage = languages.find((lang) => lang.code === value);
          return (
            <CustomMenuItem
              label={selectedLanguage?.label || ""}
              icon={<IconGlobe width={20} height={20} color={Colors.primary._800} />}
              hasHover={false}
            />
          );
        }}
      >
        {languages.map((language) => (
          <CustomMenuItem
            key={language.label}
            label={language.label}
            value={language.code}
            disabled={language.code === currLanguage}
          />
        ))}
      </CustomSelect>
    </FormControl>
  );
};
